import authHeader from "../../authentication/authservices/auth-header";
import apiClient from "../../http-common";

//vacant Beds
export const fetchUserActionsByMenuId = (menuId) => {
  return apiClient.get(`/functionality/getUserActions/${menuId}`, {
    headers: authHeader(),
  });
};
